export default __webpack_public_path__ + "static/media/iron_throne.f1695aac.jpg";